(() => {
  const storageKey = 'cybist-vat-display';
  const root = document.documentElement;

  const readMode = () => {
    try {
      return localStorage.getItem(storageKey) === 'inc' ? 'inc' : 'ex';
    } catch (error) {
      return root.dataset.cybistVatDisplay === 'inc' ? 'inc' : 'ex';
    }
  };

  const applyMode = (mode, persist = false) => {
    const nextMode = mode === 'inc' ? 'inc' : 'ex';
    root.dataset.cybistVatDisplay = nextMode;

    if (persist) {
      try {
        localStorage.setItem(storageKey, nextMode);
      } catch (error) {
        // The visual preference still works if storage is unavailable.
      }
    }

    document.querySelectorAll('[data-cybist-vat-toggle]').forEach((button) => {
      const includesVat = nextMode === 'inc';
      button.setAttribute('aria-checked', includesVat ? 'true' : 'false');

      const status = button.querySelector('[data-cybist-vat-status]');
      if (status) {
        status.textContent = includesVat
          ? 'Prices currently include VAT'
          : 'Prices currently exclude VAT';
      }
    });

    document.dispatchEvent(new CustomEvent('cybist:vat-display-change', {
      detail: { mode: nextMode }
    }));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cybist-vat-toggle]');
    if (!button) return;

    const nextMode = root.dataset.cybistVatDisplay === 'inc' ? 'ex' : 'inc';
    applyMode(nextMode, true);
  });

  const showCopyResult = (button, copied) => {
    button.textContent = copied ? 'Copied ✓' : 'Copy manually';
    window.setTimeout(() => {
      button.textContent = 'Copy';
    }, 2200);
  };

  const fallbackCopyEmail = (button, email) => {
    const field = document.createElement('textarea');
    field.value = email;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();

    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    document.body.removeChild(field);
    showCopyResult(button, copied);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cybist-copy-email]');
    if (!button) return;

    const email = button.dataset.cybistCopyEmail;

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(email)
        .then(() => showCopyResult(button, true))
        .catch(() => fallbackCopyEmail(button, email));
    } else {
      fallbackCopyEmail(button, email);
    }
  });

  document.addEventListener('DOMContentLoaded', () => applyMode(readMode()));
  document.addEventListener('shopify:section:load', () => applyMode(readMode()));

  applyMode(readMode());
})();
